import { useEffect } from 'react';

var useOnKeypress = function useOnKeypress(callback, element) {
  var keyEventHandler = function keyEventHandler(e) {
    if (element) {
      callback(e);
    }
  };
  useEffect(function () {
    if (element) {
      element.addEventListener('keydown', keyEventHandler);
    }
    return function () {
      if (element) {
        element.removeEventListener('keydown', keyEventHandler);
      }
    };
  }, [callback, element]);
};

export { useOnKeypress };
